import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { classNames } from '../../../../../../utils/classname';
import Embed from '../../../../../foundation/components/Embed';
import { IN_VIEWPORT_LOAD_STRATEGY } from '../../../../../foundation/components/Embed/Embed.constants';
import { EmbedAspectRatioPropType, EmbedLoadStrategyPropType } from '../../../../../foundation/components/Embed/Embed.types';
var defaultProps = {
  url: '',
  aspectRatio: null,
  className: '',
  placeholder: '',
  loadStrategy: IN_VIEWPORT_LOAD_STRATEGY,
  icon: ''
};
export default function DefaultPlayer(_ref) {
  var url = _ref.url,
    aspectRatio = _ref.aspectRatio,
    className = _ref.className,
    placeholder = _ref.placeholder,
    loadStrategy = _ref.loadStrategy,
    icon = _ref.icon;
  var finalClassName = classNames(_defineProperty({
    video: true,
    "default": true
  }, className, true));
  return /*#__PURE__*/React.createElement(Embed, {
    url: url,
    source: "default",
    className: finalClassName,
    aspectRatio: aspectRatio,
    loadStrategy: loadStrategy,
    placeholder: placeholder,
    icon: icon
  });
}
DefaultPlayer.defaultProps = defaultProps;